import { NumberLiteralType } from "typescript";

export class MyDonations {
    donationDate: Date;
    donationAmount: number;
  }
  